import React, { useEffect, useRef, useState } from "react";
import { apiCall } from "../../../../utils/axiosService";
import { apiResponse } from "../../../../utils/apiResponse";
import { API_URL } from "../../../../utils/apiRoutes";
import { commonService } from "../../../../utils/commonService";
import Comments from "../Comments/Comment";
import { Button, Overlay, OverlayTrigger, Popover, Row, Table, Form } from "react-bootstrap";
import emailIcon from "../../../../Assets/Images/Email.svg";
import { useParams } from "react-router-dom";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { useSelector } from "react-redux";
import { compName, week } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";
import moment from "moment";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import { MultiSelect } from "primereact/multiselect";
import Loader from "../../../Loader/Loader";
import filter from "../../../../Assets/Images/Configuration/filter-icon.svg";
import Filter_MonthDowRoomTypeRatePlanChannels from "./Models/Filter_MonthDowRoomTypeRatePlanChannels";

const RNXAnalysis1_Day = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
    topfilterdata,
    topviewoption
}) => {
    const [viewOption, setViewOption] = useState("Graph");

    useEffect(() => {
        if (topviewoption) {
            setViewOption(topviewoption)
        }
    }, [topviewoption]);

    const widgetDetailRef = useRef();

    const [widgetModal, setWidgetModal] = useState(false);

    const closeWidgetModal = () => { setWidgetModal(false); };

    const { snapshottitle, propertyCode, snapshotId } = useParams();

    const defaultAsOfDateFromRTK = useSelector((store) => store.headerProperty.defaultAsOfDate);

    const [tblids, settblids] = useState({
        id1: commonService.GenerateGUID(),
        id2: commonService.GenerateGUID(),
        id3: commonService.GenerateGUID(),
        id4: commonService.GenerateGUID(),
    });

    const [filterData, setFilterData] = useState({ year: new Date().getFullYear(), months: [], dow: [], ratecodes: [], roomtypes: [], combinedchannels: [] });

    const [CurrentYearData, setCurrentYearData] = useState([]);

    const [CurrentYearDPData, setCurrentYearDPData] = useState([]);

    const [FinalData, setFinalData] = useState([]);


    const [STLYData, setSTLYData] = useState([]);


    const GetCurrentYearData = async () => {
        setCurrentYearData([]);
        try {
            let TableResponse = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.SnapShot + API_URL.RNX.RNX_DOW_WISE_SUMMARY,
                    body: {
                        asofdate: para?.asOfDate,
                        propertycode: para?.propertyCode,
                        year: filterData.year,
                        months: filterData.months ? filterData.months.map(item => item.code) : [],
                        daysofweek: filterData.dow ? filterData.dow.map(item => item.code) : [],
                        ratecodes: filterData.ratecodes ? filterData.ratecodes.map(item => item.code) : [],
                        roomtypes: filterData.roomtypes ? filterData.roomtypes.map(item => item.code) : [],
                        channels: filterData.combinedchannels ? filterData.combinedchannels.map(item => item.code) : [],
                    },
                },
                false
            );
            let response = apiResponse(false, TableResponse);
            if (response?.isValidate) {
                setCurrentYearData(response?.data?.data);
            }
        } catch (error) {

        }
    };

    const GetSTLYData = async () => {

        setSTLYData([]);
        try {
            let TableResponse = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.SnapShot + API_URL.RNX.RNX_DOW_WISE_SUMMARY_STLY,
                    body: {
                        asofdate: para?.asOfDate,
                        propertycode: para?.propertyCode,
                        year: filterData.year,
                        months: filterData.months ? filterData.months.map(item => item.code) : [],
                        daysofweek: filterData.dow ? filterData.dow.map(item => item.code) : [],
                        ratecodes: filterData.ratecodes ? filterData.ratecodes.map(item => item.code) : [],
                        roomtypes: filterData.roomtypes ? filterData.roomtypes.map(item => item.code) : [],
                        channels: filterData.combinedchannels ? filterData.combinedchannels.map(item => item.code) : [],
                    },
                },
                false
            );
            let response = apiResponse(false, TableResponse);
            if (response?.isValidate) {
                setSTLYData(response?.data?.data);
            }
        } catch (error) {

        }
    };


    const GetCurrentYearDPData = async () => {
        setCurrentYearDPData([]);
        try {
            let TableResponse = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.SnapShot +
                        API_URL.RNX.RNX_DOW_WISE_SUMMARY_PER_TOTAL_DOW,
                    body: {
                        asofdate: para?.asOfDate,
                        propertycode: para?.propertyCode,
                        year: filterData.year,
                        months: filterData.months ? filterData.months.map(item => item.code) : [],
                        daysofweek: filterData.dow ? filterData.dow.map(item => item.code) : [],
                        ratecodes: filterData.ratecodes ? filterData.ratecodes.map(item => item.code) : [],
                        roomtypes: filterData.roomtypes ? filterData.roomtypes.map(item => item.code) : [],
                        channels: filterData.combinedchannels ? filterData.combinedchannels.map(item => item.code) : [],
                    },
                },
                false
            );
            let response = apiResponse(false, TableResponse);
            if (response?.isValidate) {
                setCurrentYearDPData(response?.data?.data);
            }
        } catch (error) {

        }
    };

    const [dataLoading, setDataLoading] = useState(false);

    const GetAllData = async () => {
        setDataLoading(true);
        await GetCurrentYearData();
        await GetCurrentYearDPData();
        await GetSTLYData();
        setDataLoading(false);
    };

    useEffect(() => {
        if (api === 0) {
            const dayData = week.map(m => ({
                day: m,
                currentyearrooms: 0,
                currentyearrpd: 0,
                currentyearrev: 0,
                currentyearrevpd: 0,
                currentyearadr: 0,

                stlyrooms: 0,
                stlyroomsdiff: 0,
                stlyrev: 0,
                stlyrevdiff: 0,
                stlyadr: 0,
                stlyadrdiff: 0,

                lastyearrooms: 0,
                lastyearroomsdiff: 0,
                lastyearrpd: 0,
                lastyearrev: 0,
                lastyearrevdiff: 0,
                lastyearrevpd: 0,
                lastyearadr: 0,
                lastyearadrdiff: 0,

            }));


            setFinalData(dayData);
        } else {
            if (para?.asOfDate) {
                GetAllData();
            }
        }
    }, [para?.asOfDate, filterData]);

    useEffect(() => {
        if (topfilterdata) {
            setFilterData(topfilterdata)
        }
    }, [topfilterdata]);

    useEffect(() => {
        if (!dataLoading) {
            let _FinalData = [];


            week.map((m) => {

                let currentyearrooms = 0,
                    currentyearrpd = 0,
                    currentyearrev = 0,
                    currentyearrevpd = 0,
                    currentyearadr = 0,

                    stlyrooms = 0,
                    stlyroomsdiff = 0,
                    stlyrev = 0,
                    stlyrevdiff = 0,
                    stlyadr = 0,
                    stlyadrdiff = 0,

                    lastyearrooms = 0,
                    lastyearroomsdiff = 0,
                    lastyearrpd = 0,
                    lastyearrev = 0,
                    lastyearrevdiff = 0,
                    lastyearrevpd = 0,
                    lastyearadr = 0,
                    lastyearadrdiff = 0;

                let CD = CurrentYearData.filter((d) => d.dayname.toUpperCase() === m.substr(0, 3).toUpperCase());


                if (CD && CD.length > 0) {
                    currentyearrooms = CD[0].total_roomnights ? parseInt(CD[0].total_roomnights) : 0;
                    currentyearrev = CD[0].total_revenue ? parseInt(CD[0].total_revenue) : 0;
                    currentyearadr = CD[0].adr ? parseInt(CD[0].adr) : 0;

                    lastyearrooms = CD[0].lastyear_total_roomnights ? parseInt(CD[0].lastyear_total_roomnights) : 0;
                    lastyearroomsdiff = commonService.GrowthFormula(currentyearrooms, lastyearrooms);

                    lastyearrev = CD[0].lastyear_total_revenue ? parseInt(CD[0].lastyear_total_revenue) : 0;
                    lastyearrevdiff = commonService.GrowthFormula(currentyearrev, lastyearrev);

                    lastyearadr = CD[0].lastyear_adr ? parseInt(CD[0].lastyear_adr) : 0;
                    lastyearadrdiff = commonService.GrowthFormula(currentyearadr, lastyearadr);

                }

                let LD = CurrentYearDPData.filter((d) => d.dayname.toUpperCase() === m.substr(0, 3).toUpperCase());
                if (LD && LD.length > 0) {
                    currentyearrpd = LD[0].avg_roomnights ? parseInt(LD[0].avg_roomnights) : 0;
                    currentyearrevpd = LD[0].avg_revenue ? parseInt(LD[0].avg_revenue) : 0;

                    lastyearrpd = LD[0].lastyear_avg_roomnights ? parseInt(LD[0].lastyear_avg_roomnights) : 0;
                    lastyearrevpd = LD[0].lastyear_avg_revenue ? parseInt(LD[0].lastyear_avg_revenue) : 0;
                }

                let SD = STLYData.filter((d) => d.dayname.toUpperCase() === m.substr(0, 3).toUpperCase());
                if (SD && SD.length > 0) {
                    stlyrooms = SD[0].stly_total_roomnights ? parseInt(SD[0].stly_total_roomnights) : 0;
                    stlyroomsdiff = commonService.GrowthFormula(currentyearrooms, stlyrooms);

                    stlyrev = SD[0].stly_total_revenue ? parseInt(SD[0].stly_total_revenue) : 0;
                    stlyrevdiff = commonService.GrowthFormula(currentyearrev, stlyrev);

                    stlyadr = SD[0].stly_adr ? parseInt(SD[0].stly_adr) : 0;
                    stlyadrdiff = commonService.GrowthFormula(currentyearadr, stlyadr);

                }



                _FinalData.push({
                    day: m,
                    currentyearrooms: currentyearrooms,
                    currentyearrpd: currentyearrpd,
                    currentyearrev: currentyearrev,
                    currentyearrevpd: currentyearrevpd,
                    currentyearadr: currentyearadr,

                    stlyrooms: stlyrooms,
                    stlyroomsdiff: stlyroomsdiff,
                    stlyrev: stlyrev,
                    stlyrevdiff: stlyrevdiff,
                    stlyadr: stlyadr,
                    stlyadrdiff: stlyadrdiff,

                    lastyearrooms: lastyearrooms,
                    lastyearroomsdiff: lastyearroomsdiff,
                    lastyearrpd: lastyearrpd,
                    lastyearrev: lastyearrev,
                    lastyearrevdiff: lastyearrevdiff,
                    lastyearrevpd: lastyearrevpd,
                    lastyearadr: lastyearadr,
                    lastyearadrdiff: lastyearadrdiff,
                });
            });


            setFinalData(_FinalData);
        }
    }, [dataLoading]);

    let AllWidgetContainer = document.getElementById(
        "RNXAnalysis1_Day"
    );

    if (AllWidgetContainer !== null) {
        let CW = AllWidgetContainer.clientWidth;
        CW = CW - 120;
        CW = Math.round(CW / 3);
        if (CW < 250) {
            CW = 250;
        }
        let Widget = AllWidgetContainer.getElementsByClassName(
            "allTableTogather-widget"
        );
        if (Widget !== null && Widget.length !== 0) {
            for (let i = 0; i < Widget.length; i++) {
                Widget[i].style.width = CW + "px";
            }
        }
    }

    const [DisplayFilter, setDisplayFilter] = useState({
        IsDisplay: false,
        Target: null,
        Position: "top",
    });

    const ShowFilter = (event) => {
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        if (Top + 400 > window.innerHeight) {
            Position = "top";
        }
        setDisplayFilter({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };

    const CloseFilter = (data) => {
        setDisplayFilter({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
        setFilterData(data)
    };

    return (
        <div
            className="widget-container"
            style={{ position: "relative", padding: "0 5px" }}
        >
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">

                    {
                        !topfilterdata &&
                        <Button id={commonService.generateGlobalClickTrackerID("RNXAnalysis1_Day", "filter", propertyCode)} className="heading-menu-btns" type="button" title="Filter"
                            onClick={(e) => {
                                ShowFilter(e);
                            }}>
                            <img
                                src={filter}
                                alt="Filter"
                            />
                        </Button>
                    }

                    <Button className="heading-menu-btns" type="button" title="Send Mail">
                        <img id={commonService.generateGlobalClickTrackerID("RNXAnalysis1_Day", "emailicon", propertyCode)}
                            src={emailIcon}
                            alt="emailIcon"
                            onClick={() => {
                                commonService.fnSendWidgetMail(
                                    tblids.id1 +
                                    "," +
                                    tblids.id2 +
                                    "," +
                                    tblids.id3 +
                                    "," +
                                    tblids.id4,
                                    "Snapshot By Month",
                                    snapshotId,
                                    defaultAsOfDateFromRTK,
                                    "",
                                    para?.widgetId
                                );
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("RNXAnalysis1_Day", "info", propertyCode)}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.annualSummary,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("RNXAnalysis1_Day", "menuicon", propertyCode)}
                            src={downloadIcon}
                            alt="menuIcon"
                            import={
                                tblids.id1 +
                                "," +
                                tblids.id2 +
                                "," +
                                tblids.id3 +
                                "," +
                                tblids.id4
                            }
                            onClick={() => {
                                commonService.fnExportInCSV(
                                    tblids.id1 +
                                    "," +
                                    tblids.id2 +
                                    "," +
                                    tblids.id3 +
                                    "," +
                                    tblids.id4,
                                    `${para?.propertyCode}-Annual Summary-${moment(
                                        new Date()
                                    ).format("MMDDYYYY")}`
                                );
                            }}
                        />
                    </Button>

                    {
                        DisplayFilter.IsDisplay &&
                        <Overlay
                            show={DisplayFilter.IsDisplay}
                            target={DisplayFilter.Target}
                            placement={DisplayFilter.Position}
                        >
                            <Popover
                                id="popover-contained"
                                className="FilterPopover"
                            >
                                <Filter_MonthDowRoomTypeRatePlanChannels show={DisplayFilter.IsDisplay} closeModal={CloseFilter} para={para} dropdownSelectedData={filterData} />
                            </Popover>
                        </Overlay>
                    }

                </div>
            )
                
            }
            <div className="allTableTogatherWrapper" id="RNXAnalysis1_Day">
                <div style={{ display: "flex", gridGap: "10px" }}>
                    <div style={{ width: "120px", flex: "none" }}>
                        <div className="ViewPropertySetupTable monthSelectTable">
                            <div className="stripped__table">
                                <Table id={tblids.id1} responsive>
                                    <thead>
                                        <tr>
                                            <th>

                                            </th>
                                        </tr>
                                        <tr>
                                            <th>Month</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            dataLoading ?
                                                <tr
                                                    style={{
                                                        height: "80px",
                                                        position: "relative",
                                                    }}
                                                >
                                                    <Loader />
                                                </tr>
                                                :
                                                <>
                                                    {week?.map((item, index) => (
                                                        <tr key={item}>
                                                            <td>{item}</td>
                                                        </tr>
                                                    ))}

                                                </>
                                        }
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div>
                    <div className="table-responsive" style={{ flex: "1" }}>
                        <div
                            className="allTableTogather"
                            style={{ display: "flex", gridGap: "10px" }}
                        >
                            <div className="p-0 allTableTogather-widget">
                                <div className="ViewPropertySetupTable">
                                    <div className="stripped__table">
                                        <Table id={tblids.id2} responsive>
                                            <thead>
                                                <tr>
                                                    <th colSpan={5} className={"text-center"}>{filterData.year}</th>
                                                </tr>
                                                <tr>
                                                    <th>ROOMS</th>
                                                    <th>RPD</th>
                                                    <th className={"text-end"}>ADR</th>
                                                    <th className={"text-end"}>REV</th>
                                                    <th className={"text-end"}>REVPD</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    dataLoading ?
                                                        <tr
                                                            style={{
                                                                height: "80px",
                                                                position: "relative",
                                                            }}
                                                        >
                                                            <Loader />
                                                        </tr>
                                                        :
                                                        <>
                                                            {FinalData?.map((item, index) => (
                                                                <tr>
                                                                    <td className={` ${item.day === "Total" ? "boldTd" : ""}`}>{item.currentyearrooms}</td>
                                                                    <td className={` ${item.day === "Total" ? "boldTd" : ""}`}>{item.currentyearrpd}</td>
                                                                    <td className={`text-end ${item.day === "Total" ? "boldTd" : ""}`}>{commonService.formateAmount(item.currentyearadr)}</td>
                                                                    <td className={`text-end ${item.day === "Total" ? "boldTd" : ""}`}>{commonService.formateAmount(item.currentyearrev)}</td>
                                                                    <td className={`text-end ${item.day === "Total" ? "boldTd" : ""}`}>{commonService.formateAmount(item.currentyearrevpd)}</td>
                                                                </tr>
                                                            ))}
                                                        </>
                                                }
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>
                            <div className="p-0 allTableTogather-widget">
                                <div className="ViewPropertySetupTable">
                                    <div className="stripped__table">
                                        <Table id={tblids.id3} responsive>
                                            <thead>
                                                <tr>
                                                    <th colSpan="6" className={"text-center"}>
                                                        STLY
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th colSpan="1">ROOMS</th>
                                                    <th colSpan="1" className="text-center cursor-pointer" title="Current ROOMS vs STLY" >VAR</th>
                                                    <th colSpan="1" className={"text-end"}>ADR</th>
                                                    <th colSpan="1" className="text-center cursor-pointer" title="Current ADR vs STLY" >VAR</th>
                                                    <th colSpan="1" className={"text-end"}>REV</th>
                                                    <th colSpan="1" className="text-center cursor-pointer" title="Current REV vs STLY" >VAR</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    dataLoading ?
                                                        <tr
                                                            style={{
                                                                height: "80px",
                                                                position: "relative",
                                                            }}
                                                        >
                                                            <Loader />
                                                        </tr>
                                                        :
                                                        <>
                                                            {FinalData?.map((item, index) => (
                                                                <tr>
                                                                    <td className={` ${item.day === "Total" ? "boldTd" : ""}`}>{item.stlyrooms}</td>
                                                                    <td className={`text-center ${item.day === "Total" ? "boldTd" : ""} ${item.stlyroomsdiff !== 0 ? item.stlyroomsdiff > 0 ? "greenText" : "redText" : ""}`}>{item.stlyroomsdiff}%</td>
                                                                    <td className={`text-end ${item.day === "Total" ? "boldTd" : ""}`}>{commonService.formateAmount(item.stlyadr)}</td>
                                                                    <td className={`text-center ${item.day === "Total" ? "boldTd" : ""} ${item.stlyadrdiff !== 0 ? item.stlyadrdiff > 0 ? "greenText" : "redText" : ""}`}>{item.stlyadrdiff}%</td>
                                                                    <td className={`text-end ${item.day === "Total" ? "boldTd" : ""}`}>{commonService.formateAmount(item.stlyrev)}</td>
                                                                    <td className={`text-center ${item.day === "Total" ? "boldTd" : ""} ${item.stlyrevdiff !== 0 ? item.stlyrevdiff > 0 ? "greenText" : "redText" : ""}`}>{item.stlyrevdiff}%</td>
                                                                </tr>
                                                            ))}
                                                        </>
                                                }

                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>
                            <div className="p-0 allTableTogather-widget">
                                <div className="ViewPropertySetupTable">
                                    <div className="stripped__table">
                                        <Table id={tblids.id4} responsive>
                                            <thead>
                                                <tr>
                                                    <th colSpan="8" className={"text-center"}>
                                                        {filterData.year - 1}
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th colSpan="1">ROOMS</th>
                                                    <th colSpan="1" className="text-center cursor-pointer" title="Current ROOMS vs Total LY">VAR</th>
                                                    <th >RPD</th>
                                                    <th colSpan="1" className={"text-end"}>ADR</th>
                                                    <th colSpan="1" className="text-center cursor-pointer" title="Current ADR vs Total LY">VAR</th>
                                                    <th colSpan="1" className={"text-center"}>REV</th>
                                                    <th colSpan="1" className="text-center cursor-pointer" title="Current REV vs Total LY">VAR</th>
                                                    <th className={"text-end"}>REVPD</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    dataLoading ?
                                                        <tr
                                                            style={{
                                                                height: "80px",
                                                                position: "relative",
                                                            }}
                                                        >
                                                            <Loader />
                                                        </tr>
                                                        :
                                                        <>
                                                            {FinalData?.map((item, index) => (
                                                                <tr>
                                                                    <td className={` ${item.day === "Total" ? "boldTd" : ""}`}>{item.lastyearrooms}</td>
                                                                    <td className={`text-center ${item.day === "Total" ? "boldTd" : ""} ${item.lastyearroomsdiff !== 0 ? item.lastyearroomsdiff > 0 ? "greenText" : "redText" : ""}`}>{item.lastyearroomsdiff}%</td>
                                                                    <td className={` ${item.day === "Total" ? "boldTd" : ""}`}>{item.lastyearrpd}</td>
                                                                    <td className={`text-end ${item.day === "Total" ? "boldTd" : ""}`}>{commonService.formateAmount(item.lastyearadr)}</td>
                                                                    <td className={`text-center ${item.day === "Total" ? "boldTd" : ""} ${item.lastyearadrdiff !== 0 ? item.lastyearadrdiff > 0 ? "greenText" : "redText" : ""}`}>{item.lastyearadrdiff}%</td>
                                                                    <td className={`text-end ${item.day === "Total" ? "boldTd" : ""}`}>{commonService.formateAmount(item.lastyearrev)}</td>
                                                                    <td className={`text-center ${item.day === "Total" ? "boldTd" : ""} ${item.lastyearrevdiff !== 0 ? item.lastyearrevdiff > 0 ? "greenText" : "redText" : ""}`}>{item.lastyearrevdiff}%</td>
                                                                    <td className={`text-end ${item.day === "Total" ? "boldTd" : ""}`}>{commonService.formateAmount(item.lastyearrevpd)}</td>
                                                                </tr>
                                                            ))}
                                                        </>
                                                }
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}

            {api !== 0 && !topfilterdata && (
                <Comments widgetDetails={para} editorId={"editor" + tblids.id1} />
            )}
        </div>
    );
};

export default RNXAnalysis1_Day;
